module.exports = __webpack_public_path__ + "assets/049762e4906ce56e8a48d397d8775474.png";